import React from "react";
import { useLocation } from "react-router-dom";
import { BiCheckCircle } from "react-icons/bi";

const CallRequestComplete = () => {
  const location = useLocation();

  const { selectedDate, selectedTime } = location.state;

  // 날짜와 요일 포맷팅
  const dateObject = new Date(selectedDate);
  const formattedDate = dateObject.toLocaleDateString("ko-KR", { year: "numeric", month: "long", day: "numeric", weekday: "long" });

  return (
    <div className="sm:min-w-screen md:max-w-[400px] mx-auto min-h-screen flex flex-col justify-center items-center bg-white py-4">
      <div className="flex flex-col items-center">
        {/* <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-green-500 mb-4" /> */}
        <BiCheckCircle size="4rem" className="text-[#3e9ff9] mb-8" />
        {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover mb-4" /> */}
        <span className="text-2xl font-bold text-center text-[#535353] mt-8 mb-8">상담 신청이 완료되었습니다</span>
        <span className="text-sm text-center text-[#535353]">
          {formattedDate} {selectedTime}에
        </span>
        <span className="text-sm text-center text-[#535353]">상담이 예약되었습니다.</span>
      </div>
    </div>
  );
};

export default CallRequestComplete;
